import { createUseStyles } from "react-jss";
import { colors } from "../../../../constants/colors";
import { breakpoints } from "../../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  statusContainer: {
    borderRadius: "16px",
    padding: "2px 8px",
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "18px",
    display: "flex",
    alignItems: "center"
  },
  scheduled: {
    extend: "statusContainer",
    backgroundColor: colors.veryLightGrey,
    color: colors.grey,
  },
  canceled: {
    extend: "statusContainer",
    backgroundColor: colors.lightRed,
    color: colors.darkRed,
    "& svg": {
      "& path": {
        stroke: colors.red
      }
    }
  },
  delayed: {
    extend: "statusContainer",
    backgroundColor: colors.lightRed,
    color: colors.darkRed,
    "& svg": {
      "& path": {
        stroke: colors.red
      }
    }
  },
  notavailable: {
    extend: "statusContainer",
    backgroundColor: colors.veryLightGrey,
    color: colors.grey,
  },
  diverted :{
    extend: "statusContainer",
    backgroundColor: colors.veryLightOrange,
    color: colors.orange,
  },
  ontime: {
    extend: "statusContainer",
    backgroundColor: colors.green50,
    color: colors.green700,
  },
  arrived: {
    backgroundColor: colors.veryLightGrey,
    color: colors.grey,
    extend: "statusContainer",
    "& svg": {
      "& path": {
        stroke: colors.inactiveGrey
      }
    }
  },
  details: {
    minWidth: "210px",
    marginLeft: "12px",
    "& p": {
      margin: 0,
      fontSize: "14px",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    "& p:first-child": {
      color: colors.lightBlack,
      fontWeight: "500",
      lineHeight: "20px",
    },
    "& p:last-child": {
      color: colors.mediumGrey,
      fontWeight: "400",
      lineHeight: "20px",
    }
  },
  startDate: {
    fontSize: "14px",
    fontWeight: "400",
    color: colors.lightBlack
  },
  startTime: {
    fontSize: "14px",
    fontWeight: "400",
    color: colors.mediumGrey
  },
  departureStatus: {
    whiteSpace: "nowrap",
    overflow: "visible !important",
    textOverflow: "unset !important",
    "& div": {
      whiteSpace: "nowrap",
      overflow: "visible !important",
      textOverflow: "unset !important",
    }
  },
  nameWrapper: {
    display: "flex",
    minWidth: "100px",
  },
  initialsAvatar: {
    alignSelf: "center",
    width: "40px",
    height: "40px",
    background: colors.veryLightGrey,
    borderRadius: "200px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: "40px",
    "& span": {
      color: colors.mediumGrey
    }
  },
  badge: {
    color: colors.grayBlue700,
    backgroundColor: colors.grayBlue50,
    padding: "2px 6px 2px 8px",
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    height: "22px"
  },
  badgeText: {
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "18px"
  },
  statusIcon: {
    marginRight: "4px",
    flexShrink: 0
  },
  detailsWrapper: {
    display: "flex",
    justifyContent: "space-between"
  },
  link: {
    textDecoration: "none",
    fontSize: 14,
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.lightBlack
  },
  name: {
    maxWidth: "180px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    height: "20px",
    "&:focus-visible":{
      border: "1px solid " + colors.primary500Blue
    },
  },
}));

export default styles;